
import Vue, { CreateElement } from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as Icons from "@/lib/icons/icons";
import { IconName } from "@/lib/icons/icons";

@Component({})
export default class RawIcon extends Vue {
  @Prop()
  icon!: IconName;

  render(h: CreateElement) {
    const IconsComponents = Icons as unknown as Record<
      IconName,
      typeof Component
    >;

    if (!IconsComponents[this.icon]) {
      // throw to get a good Vue stack trace. Otherwise it's a PITA to know which component didn't add the correct icon
      throw new Error(`${this.icon} is not a valid Icon name`);
    }

    return h(IconsComponents[this.icon]);
  }
}
